<template>
	<div class="advert-manage-container">
		<el-card shadow="never">
			<div class="header" slot="header">
				<div class="input-name">
					<div class="name">名称:</div>
					<el-input v-model="name" placeholder="请输入名称"></el-input>
				</div>
				<el-button type="primary">搜索</el-button>
				<el-button type="primary" icon="el-icon-plus">新增文件夹</el-button>
				<el-button icon="el-icon-price-tag">管理标签</el-button>
			</div>
			<div class="file-list">
				<div class="file-item" v-for="(item, index) in folderList" :key="index">
					<div class="file-li">
						<div class="file-icon">
							<i class="el-icon-folder" :style="{ color: item.type === 'system' ? '#e6a23c' : '#409EFF' }"></i>
						</div>
						<div>
							<div>
								<span style="margin-right: 12px; font-weight: bold">{{ item.name }}</span>
								<el-tag v-if="item.type === 'system'" size="mini" style="font-size: 10px">系统文件夹</el-tag>
							</div>
							<div class="count">
								<span style="margin-right: 15px">目录数：{{ item.dirCount }}</span>
								<span>文档数：{{ item.docCount }}</span>
							</div>
						</div>
					</div>

					<el-dropdown class="more" size="small">
						<i class="el-icon-more"></i>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>打开</el-dropdown-item>
							<el-dropdown-item>查看详情</el-dropdown-item>
							<el-dropdown-item>设置权限</el-dropdown-item>
							<el-dropdown-item v-if="item.type !== 'system'">修改名称</el-dropdown-item>
							<el-dropdown-item v-if="item.type !== 'system'" style="color: #f56c6c">删除文件夹</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				name: '',
				folderList: [
					{ name: '合同', type: 'system', dirCount: 0, docCount: 0 },
					{ name: '收据', type: 'system', dirCount: 0, docCount: 0 },
					{ name: '营销知识库', type: 'business', dirCount: 28, docCount: 346 },
					{ name: '工程知识库', type: 'business', dirCount: 28, docCount: 346 },
					{ name: '设计知识库', type: 'business', dirCount: 28, docCount: 346 },
					{ name: '行政管理制度', type: 'business', dirCount: 28, docCount: 346 },
					{ name: '内部培训课程', type: 'business', dirCount: 28, docCount: 346 },
					{ name: '财务报表', type: 'business', dirCount: 15, docCount: 128 },
					{ name: '合同模板', type: 'business', dirCount: 12, docCount: 89 },
					{ name: '项目文档', type: 'business', dirCount: 45, docCount: 567 },
				],
			};
		},
	};
</script>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		color: #1c1c1c;
		text-align: left;
	}

	.header,
	.input-name {
		display: flex;
		align-items: center;
	}
	.input-name {
		margin-right: 10px;
	}
	.name {
		width: 50px;
	}
	.file-list {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		gap: 12px;
		.file-item {
			width: calc(100% / 4 - 12px);
			height: 80px;
			border-radius: 12px;
			box-sizing: border-box;
			padding: 12px 14px;
			border: 1px solid #e0e0e0;
			margin-bottom: 12px;
			transition: all 0.3s ease;
			position: relative;
			.more {
				position: absolute;
				right: 14px;
				top: 12px;
				transform: rotate(90deg);
				color: #666;
				cursor: pointer;
			}
			.file-li {
				cursor: pointer;
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				gap: 10px;
				.file-icon {
					font-weight: bold;
					font-size: 40px;
				}
				.count {
					font-size: 12px;
					color: #999;
					margin-top: 10px;
				}
			}
		}
		.file-item:hover {
			transform: translateY(-4px);
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		}
	}
</style>
